import type { IconSvgObject } from './types';

const ZodiacCancerIcon: IconSvgObject = [
  ["circle", { cx: "6.5", cy: "9.5", r: "3.5", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "17.5", cy: "14.5", r: "3.5", transform: "rotate(180 17.5 14.5)", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3 9.5C3 5.91015 7.02944 3 12 3C15.4829 3 18.5038 4.42887 20 6.51924", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M21 14.5C21 18.0899 16.9706 21 12 21C8.51707 21 5.49623 19.5711 4 17.4808", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "3" }]
];

export default ZodiacCancerIcon;
